// extracted by mini-css-extract-plugin
module.exports = {"legendContainer":"DraftByStarsLegend_legendContainer__o7tkK","legendItem":"DraftByStarsLegend_legendItem__hl6Z_","description":"DraftByStarsLegend_description__jrnAO"};